window.Address = {
	changeCountry: function(me){
		
		// reset stuff
		var selected	= me.find(':selected');
		var countryCode = selected.val();
		var hasProvince	= selected.data('hasprovince');

		$('[class*=showWithCountry]').not('.showWithCountry_'+countryCode).hide().find('input').val('');
		$('.showWithCountry_'+countryCode).fadeIn();
		
		if(hasProvince === 'Y' && $('.hasProvince input[name*=_state]').length > 0) {
			if($('.hasProvince input[name*=_state]').tokenInput("clear") !== undefined){
				$('.hasProvince input[name*=_state]').tokenInput("clear");
				$('.hasProvince input').trigger("blur");
				$('.hasProvince').show();
			}
		} else if(hasProvince === 'N') {
			$('.hasProvince').hide();
		}
		
		if($(".tva_intra").length > 0) {
			if(me.find(':selected').attr("euro") === "Y") {
				$(".tva_intra").show();
			}else {
				$(".tva_intra").hide();
			}
		}
		
		// populate steps
	},
};

